import logoDark from "../../assets/images/logo-dark.png";
import Box from "@mui/material/Box";
import MenuIcon from "@mui/icons-material/Menu";

const HamburgerIcon = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Box
        sx={{
          flex: "none",
          margin: 2,
        }}
      >
        <MenuIcon />
      </Box>
      <Box
        sx={{
          flex: "none",
          marginLeft: "55px",
        }}
      >
        <img
          src={logoDark}
          alt="Logo"
          className="img-fluid"
          style={{ maxHeight: "50px" }}
        />
      </Box>
    </Box>
  );
};

export default HamburgerIcon;
